import { render, staticRenderFns } from "./listExpansion.vue?vue&type=template&id=38f0c49d&scoped=true"
import script from "./listExpansion.vue?vue&type=script&lang=js"
export * from "./listExpansion.vue?vue&type=script&lang=js"
import style0 from "./listExpansion.vue?vue&type=style&index=0&id=38f0c49d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0c49d",
  null
  
)

export default component.exports